import { useCallback, useEffect, useState } from 'react'
import { Grid, Paper, Typography, Button, Dialog, DialogContent } from '@material-ui/core'
import CustomTable from '../../components/CustomTable/CustomTable'
import { getProviders } from '../../api/providers.service'
import { useDispatch, useSelector } from 'react-redux'
import { setProvider } from '../../redux/features/providerSlice'
import { useHistory } from 'react-router-dom'
import { toggleModalFullscreen } from '../../redux/features/modalSlice'
import { getProviderConditions } from '../../api/providerConditions.service'
import AcceptDocuments from './AcceptDocuments'

const AccountChange = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [state, setState] = useState({
    data: [],
    loading: false,
    pages: 0,
    page: 0,
    pageSize: 2000,
    sorted: null,
    filtered: [],
    hasChanges: true
  })
  const [tableLoading, setTableLoading] = useState(true)
  const [isAcceptDocumentsModalOpen, setIsAcceptDocumentsModalOpen] = useState(false)
  const [selectedProvider, setSelectedProvider] = useState({})
  const modal = useSelector((state) => state.modal)

  const handleSetState = (values) => {
    const newState = { ...state, ...values, hasChanges: true }
    setState(newState)
  }

  const getData = useCallback(
    (nState) => {
      setTableLoading(true)
      const postObject = {
        ...(nState ? nState : state)
      }
      const data = JSON.stringify(postObject)
      getProviders(data)
        .then(({ data }) => {
          setTableLoading(false)
          setState({
            ...state,
            page: postObject.page,
            sorted: postObject.sorted,
            filtered: postObject.filtered,
            pageSize: postObject.pageSize,
            data: data.results,
            pages: data.pageCount,
            hasChanges: false
          })
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    [state]
  )

  useEffect(() => {
    if (state.hasChanges) getData()
  }, [getData, state.hasChanges])

  const fetchData = (nState) => {
    getData(nState)
  }

  const handleSelectProvider = (provider) => {
    getProviderConditions(provider.id).then((result) => {
      if (result.data.every((condition) => condition.isAccepted)) {
        setTableLoading(true)
        dispatch(setProvider(provider))
        setTableLoading(false)
        history.push('/')
      } else {
        dispatch(setProvider({}))
        setSelectedProvider(provider)
        setIsAcceptDocumentsModalOpen(true)
      }
    })
  }

  const handleCloseModalAcceptDocuments = () => {
    setIsAcceptDocumentsModalOpen(false)
  }

  const exitFullscreenModalAcceptDocuments = useCallback(() => {
    if (!isAcceptDocumentsModalOpen && modal.showFullscreenOption) {
      dispatch(toggleModalFullscreen(false))
    }
  }, [isAcceptDocumentsModalOpen, modal.showFullscreenOption, dispatch])

  useEffect(() => {
    let timeout = setTimeout(exitFullscreenModalAcceptDocuments, 500)
    return () => clearTimeout(timeout)
  }, [isAcceptDocumentsModalOpen, exitFullscreenModalAcceptDocuments])

  return (
    <Paper style={{ padding: 16 }}>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12}>
          <Typography color="secondary">PROVEEDORES</Typography>
        </Grid>
        <Grid item xs={12}>
          {state.loading ? (
            <p>
              <em>Cargando...</em>
            </p>
          ) : (
            <CustomTable
              {...state}
              tableLoading={tableLoading}
              fetchData={fetchData}
              handleSetState={handleSetState}
              columns={[
                {
                  Header: 'Código',
                  accessor: 'id',
                  filterable: true,
                  sortable: true,
                  Cell: (props) => <span style={{ float: 'left' }}>{props.value}</span>
                },
                {
                  Header: 'Proveedor',
                  accessor: 'name',
                  filterable: true,
                  sortable: true,
                  Cell: (props) => <span style={{ float: 'left' }}>{props.value}</span>
                },
                {
                  Header: 'Comprador',
                  accessor: 'buyerName',
                  filterable: true,
                  sortable: true,
                  idSort: 'buyer',
                  Cell: (props) => <span style={{ float: 'left' }}>{props.value}</span>
                },
                {
                  Header: 'Razón Social',
                  accessor: 'corporateName',
                  filterable: true,
                  sortable: true,
                  idSort: 'description',
                  Cell: (props) => <span style={{ float: 'left' }}>{props.value}</span>
                },
                {
                  Header: '',
                  accessor: 'impersonate',
                  sortable: false,
                  Cell: (props) => (
                    <span>
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        onClick={() => handleSelectProvider(props.row.original)}
                      >
                        Seleccionar
                      </Button>
                    </span>
                  ),
                  width: 45
                }
              ]}
              filterProps={[
                { placeholder: 'Filtrar código...', id: 'id', value: '' },
                { placeholder: 'Filtrar proveedor...', id: 'name', value: '' },
                { placeholder: 'Filtrar comprador...', id: 'buyer', value: '' },
                { placeholder: 'Filtrar razón social...', id: 'description', value: '' },
                { maxWidth: 45 }
              ]}
              manualSortBy={true}
            />
          )}
        </Grid>
      </Grid>

      <Dialog
        open={isAcceptDocumentsModalOpen}
        onClose={handleCloseModalAcceptDocuments}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <AcceptDocuments provider={selectedProvider} onClose={handleCloseModalAcceptDocuments} />
        </DialogContent>
      </Dialog>
    </Paper>
  )
}

export default AccountChange
